<template>
  <div>
    <el-breadcrumb separator="/" style="margin-bottom: 20px;">
      <el-breadcrumb-item el-breadcrumb-item :to="{ path: '/personal/batch' }">个人奖申报批次</el-breadcrumb-item>
      <el-breadcrumb-item el-breadcrumb-item :to="{ path: '/personal?batchId=' +  $route.query.batchId }">个人奖申报</el-breadcrumb-item>
      <!-- <el-breadcrumb-item>{{ type == 2 ? '形式审查' : '形式受理'}}</el-breadcrumb-item> -->
      <el-breadcrumb-item>详情</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-tabs v-model="activeName" class="demo-tabs" v-loading="loading">
        <el-tab-pane label="获奖情况" name="fourth" v-if="(confirm != null)">
          <el-descriptions title="获奖信息" :column="1" border >
            <el-descriptions-item label="奖项类别" label-class-name="descriptions-label">
              <span>{{ declareVo.category }}</span>
              <span style="color: #165DFF;" v-if="confirm && confirm.isConfirm == 1">{{ confirm.code ? '(' + confirm.code + ')' : '(--)'  }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="是否授奖" label-class-name="descriptions-label">
              <span v-if="confirm == null">--</span>
              <span v-else>
                <span v-if="confirm.isConfirm == 1">是</span>
                <span v-if="confirm.isConfirm == 2">否</span>
              </span>
            </el-descriptions-item>
            <el-descriptions-item label="姓名" label-class-name="descriptions-label" v-if="confirm && confirm.isConfirm == 1">
              <span>{{ declareVo.name || '--' }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="联系方式" label-class-name="descriptions-label"  v-if="confirm && confirm.isConfirm == 1">
              <span>{{ confirm.phone || '--' }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="邮箱" label-class-name="descriptions-label"  v-if="confirm && confirm.isConfirm == 1">
              <span>{{ confirm.email || '--' }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="身份证" label-class-name="descriptions-label" v-if="confirm && confirm.isConfirm == 1">
              <span>{{ confirm.identityCard || '--' }}</span>
            </el-descriptions-item>
            <template v-if="confirm && confirm.isConfirm == 2">
              <el-descriptions-item label="放弃奖励证明">
                <el-link type="primary" @click="handleUploadAward(confirm.rejectAwardFileUrl)">点击下载</el-link>
                <!-- <el-link type="primary" @click="handleUploadAward(info.confirm.rejectAwardFileUrl)">点击下载</el-link> -->
              </el-descriptions-item>
            </template>
          </el-descriptions>
        </el-tab-pane>
        <el-tab-pane label="形式审查结果" name="second" v-if="declareVo.logVos && declareVo.logVos.length > 0">
          <el-descriptions title="形式审查信息" :column="4" border style="margin-bottom: 20px;" >
            <template v-for="(item, index) in declareVo.logVos" >
              <el-descriptions-item :key="index" label="审查状态" :span="1">{{item.logContent}}</el-descriptions-item>
              <el-descriptions-item :key="index" label="审查时间" :span="1">{{item.logTime}}</el-descriptions-item>
              <el-descriptions-item :key="index" label="审查意见" :span="2">
                {{item.opinion || '--'}}
              </el-descriptions-item>
            </template>
          </el-descriptions>
          <el-descriptions title="上传的盖章版材料" :column="1" border style="margin-top: 20px" v-if="declareVo.acceptExamineStatus != 5 && declareVo && declareVo.materialDeclareSupplementFile">
            <el-descriptions-item label="申报书及其他附件整合为一个PDF文件">
              <!-- <el-link v-if="info.declareVo && info.declareVo.materialDeclareSupplementFile" type="primary" @click="handleUploadFinal(info.detailVo.materialDeclareSupplementFile[0].path, info.detailVo.materialDeclareSupplementFile[0].remark)">点击下载</el-link>
              <span v-else>未上传</span> -->
              <!-- <span >{{declareVo.materialDeclareSupplementFile[0].remark}}</span> -->
              <el-link type="primary" @click="handleUploadFinal(declareVo.materialDeclareSupplementFile[0].path, declareVo.materialDeclareSupplementFile[0].remark)">点击下载</el-link>
            </el-descriptions-item>
          </el-descriptions>
        </el-tab-pane>
        <el-tab-pane label="申报信息" name="first">
          <div style="display: flex; align-items: center; margin-bottom: 15px;">
            <div style="font-size: 16px; color: #000; font-weight: 700; flex: 1">个人奖申报详情</div>
            <div v-if="status == 1">
              <!-- <el-button size="small" type="danger" v-if="declareVo.acceptExamineStatus == 4" @click="handleCh">撤回</el-button> -->
              <el-button size="small" type="warning" v-if="(declareVo.acceptExamineStatus == 5 || declareVo.isDraft == 2) && (personalState == 1 || declareVo.isDraft != 2)" @click="handleEdit">修改</el-button>
              <el-button size="small" type="warning" v-if="declareVo.isDraft == 2 && personalState == 1" @click="handleEdit">提交</el-button>
              <el-button size="small" type="primary" v-if="declareVo.acceptExamineStatus == 6 && declareVo.materialDeclareSupplementState == 1" @click="replenishs">上传材料</el-button>
              <el-button size="small" type="primary" v-if="declareVo.acceptExamineStatus == 6 && declareVo.materialDeclareSupplementState == 2" @click="ewm">下载二维码</el-button>
            </div>
          </div>
          <el-descriptions title="" :column="2" border>
            <el-descriptions-item label="奖项类别" :span="1">{{declareVo.category || '--'}}</el-descriptions-item>
            <el-descriptions-item label="姓名">{{declareVo.name || '--'}}</el-descriptions-item>
            <el-descriptions-item label="年龄">{{declareVo.age || '--'}}</el-descriptions-item>
            <el-descriptions-item label="性别">
              <span v-if="declareVo.sex == 1">男</span>
              <span v-else-if="declareVo.sex == 2">女</span>
              <span v-else>--</span>
            </el-descriptions-item>
            <el-descriptions-item label="邮箱">{{declareVo.email || '--'}}</el-descriptions-item>
            <el-descriptions-item label="职称">{{declareVo.title  || '--'}}</el-descriptions-item>
            <el-descriptions-item label="单位">{{declareVo.unit || '--'}}</el-descriptions-item>
            <el-descriptions-item label="工作年限">{{declareVo.workYears || '--'}}</el-descriptions-item>
            <el-descriptions-item label="联系方式">{{declareVo.personalPhone || '--'}}</el-descriptions-item>
            <el-descriptions-item label="最高获奖项目名称">{{declareVo.awardName || '--'}}</el-descriptions-item>
            <el-descriptions-item label="个人排名">{{declareVo.personalRank || '--'}}</el-descriptions-item>
            <el-descriptions-item label="取得年份">{{declareVo.obtainYears || '--'}}</el-descriptions-item>
            <el-descriptions-item label="授予单位">{{declareVo.grantUnit || '--'}}</el-descriptions-item>
            <el-descriptions-item label="其他获奖项目" :span="2">{{declareVo.arr1 || '--'}}</el-descriptions-item>
            <el-descriptions-item label="获得最高奖励名称">{{declareVo.highestAwardName || '--'}}</el-descriptions-item>
            <el-descriptions-item label="授予单位">{{declareVo.highestGrantUnit || '--'}}</el-descriptions-item>
            <el-descriptions-item label="其他奖励" :span="2">{{declareVo.arr2 || '--'}}</el-descriptions-item>
            <el-descriptions-item label="推荐专家" :span="2">
              <el-link type="primary" :underline="false" @click="dialogShow(declareVo.personlExperts)">详情</el-link>
            </el-descriptions-item>
            <el-descriptions-item label="申报书文件" :span="2">
              <el-link type="primary" v-for="(item, index) in declareVo.declareWordFile" :key="index" @click="handleUploadFinal(item.path, item.remark)">点击下载</el-link>
              <span v-if="!declareVo.declareWordFile">--</span>
              <!-- <el-link type="primary" :underline="false" v-for="(item, index) in info.declareWordFile" :key="index" @click="download(item.path, item.remark)">{{item.remark}}</el-link> -->
            </el-descriptions-item>
            <el-descriptions-item label="证明材料" :span="2">
              <el-link type="primary" v-for="(item, index) in declareVo.proveFile" :key="index" @click="handleUploadFinal(item.path, item.remark)">点击下载</el-link>
              <span v-if="!declareVo.proveFile">--</span>
              <!-- <el-link type="primary" :underline="false" v-for="(item, index) in info.proveFile" :key="index" @click="download(item.path, item.remark)">{{item.remark}}</el-link> -->
            </el-descriptions-item>
            <!-- <el-descriptions-item label="申报资料" :span="2">
              <span v-for="(item, index) in info.declarePdfFile" :key="index">{{item.remark}}</span>
              <span v-if="!info.declarePdfFile">--</span>
            </el-descriptions-item> -->
          </el-descriptions>
        </el-tab-pane>
      </el-tabs>
    </el-card>
    <!--  -->
    <el-dialog title="推荐专家" :visible.sync="dialog.dialogVisible" :modal-append-to-body='false' :close-on-click-modal="false" >
      <el-table :data="dialog.list" stripe highlight-current-row border :header-cell-style="{background: '#f5f7fa', color: '#333'}" >
        <el-table-column label="专家名称" prop="name"></el-table-column>
        <el-table-column label="工作单位" prop="unit"></el-table-column>
        <el-table-column label="职务" prop="position"></el-table-column>
        <el-table-column label="职称" prop="title"></el-table-column>
      </el-table>
    </el-dialog>

    <!-- 审查通过上传材料 -->
    <el-dialog class="dia" title="上传材料" :visible.sync="materials.dialogVisible" :modal-append-to-body='false' :close-on-click-modal="false" @close="closeMaterials">
      <el-form :model="materials" :rules="ruleAddForm" ref="materials" label-position="top" label-width="120px" class="demo-ruleForm">
        <el-form-item label="请将申报书及其他附件整合为一个 pdf 文件并提交（限pdf格式文件 100MB）" prop="declarePdfPath" >
          <el-checkbox-group v-model="materials.declarePdfPath" v-show="false"></el-checkbox-group>
          <My-Upload-Filebutton :limit="1" :size="100" :accept="'.pdf'" @UploadFileFun="UploadFileFuns($event, 'declarePdfPath')" :callbackShow="materials.declarePdfFiles" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="materials.dialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="materials.loading" @click="submitAdds" >确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import MyUploadFilebutton from '@/components/uploadFilebutton/UploadFilebutton'
import { getAwardPersonal, addPersonalAwardThree, getQrcodeCheckPersonal, getStPersonalEwm, getProjectAwardBatchList, getMangerStatus } from '@/api/admin'
import { increasedGetWebFiles, increasedPersonalWithdraw } from '@/api/increased'
import { uploadFileDownload, AdminDownLoadFile } from '@/api/system'
// import { AdminDownLoadFile } from '@/api/system'
export default {
  components: { MyUploadFilebutton },
  data () {
    return {
      personalState: '', // 个人状态
      activeName: 'first',
      status: '',
      loading: false,
      info: {},
      dialog: {
        list: [],
        dialogVisible: false
      },
      materials: {
        dialogVisible: false,
        loading: false,
        opinion: '',
        projectId: '',
        id: '',
        projectExcelPath: '',
        declarePdfPath: '',
        projectResultsPath: ''
      },
      ruleAddForm: {
        projectExcelPath: [{ required: true, message: '请上传文件', trigger: 'change' }],
        declarePdfPath: [{ required: true, message: '请上传文件', trigger: 'change' }],
        projectResultsPath: [{ required: true, message: '请上传文件', trigger: 'change' }]
      },
      fileList: {},
      declareVo: {},
      confirm: {}
    }
  },
  created () {
    // this.type = this.$route.query.type
    if (!this.$route.query.batchId) {
      this.$router.push({ path: '/personal/batch' })
      return false
    }
    if (!this.$route.query.id) {
      this.$router.push({ path: '/personal', query: { batchId: this.$route.query.batchId } })
      return false
    }
    getProjectAwardBatchList({ page: 1, pageSize: 500 }).then(res => {
      if (res.code == '000') {
        const batchIds = res.result.records
        const exists = batchIds.some(item => item.id === this.$route.query.batchId)
        if (!exists) {
          this.$router.push({ path: '/personal/batch' })
        } else {
          batchIds.forEach(item => {
            if (item.id == this.$route.query.batchId) {
              this.status = item.status
            }
          })
        }
      }
    })
    this.getDetails()
    this.getStatus()
    // 获取文件
    increasedGetWebFiles({}).then(res => {
      if (res.code == '000') {
        this.fileList = res.result
      }
    })
  },
  methods: {
    UploadFileFuns(e, type) {
      this.materials[type] = e
    },
    getDetails() {
      this.loading = true
      getAwardPersonal({ id: this.$route.query.id }).then(res => {
        this.loading = false
        if (res.code === '000') {
          const { confirm, declareVo } = res.result
          declareVo.arr1 = []
          declareVo.arr2 = []
          declareVo.otherAwardNumber.forEach(item => {
            if (item.type == 1) {
              declareVo.arr1.push(item.awardName + '（' + item.winningYear + '）')
            }
            if (item.type == 2) {
              declareVo.arr2.push(item.awardName)
            }
          })
          declareVo.arr1 = declareVo.arr1.join('、')
          declareVo.arr2 = declareVo.arr2.join('、')
          this.declareVo = declareVo
          this.confirm = confirm
          // this.info = res.result
          // this.info.arr1 = []
          // this.info.arr2 = []
          // this.info.otherAwardNumber.forEach(item => {
          //   if (item.type == 1) {
          //     this.info.arr1.push(item.awardName + '（' + item.winningYear + '）')
          //   }
          //   if (item.type == 2) {
          //     this.info.arr2.push(item.awardName)
          //   }
          // })
          // this.info.arr1 = this.info.arr1.join('、')
          // this.info.arr2 = this.info.arr2.join('、')
        }
      })
    },
    // 下载模板
    download(status) {
      const name = this.fileList['file' + status].remark
      uploadFileDownload({ path: this.fileList['file' + status].path }).then(res => {
        const blob = new Blob([res.data])
        // const fileName = decodeURIComponent(res.headers['content-disposition'].split(';')[1].split('filename=')[1])
        const fileName = name
        if ('download' in document.createElement('a')) { // 非IE下载
          const elink = document.createElement('a')
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href) // 释放URL 对象
          document.body.removeChild(elink)
        } else { // IE10+下载
          navigator.msSaveBlob(blob, fileName)
        }
      })
    },
    // 下载二维码、资质材料
    ewm(row, index) {
      getQrcodeCheckPersonal({ id: this.$route.query.id }).then(res => {
        if (res.code === '000') {
          getStPersonalEwm({ id: this.$route.query.id }).then(res => {
            const blob = new Blob([res.data])
            const fileName = decodeURIComponent(res.headers['content-disposition'].split(';')[1].split('filename=')[1])
            console.log(fileName)
            if ('download' in document.createElement('a')) { // 非IE下载
              const elink = document.createElement('a')
              elink.download = fileName
              elink.style.display = 'none'
              elink.href = URL.createObjectURL(blob)
              document.body.appendChild(elink)
              elink.click()
              URL.revokeObjectURL(elink.href) // 释放URL 对象
              document.body.removeChild(elink)
            } else { // IE10+下载
              navigator.msSaveBlob(blob, fileName)
            }
          })
          // this.download(8)
        }
      })
    },
    dialogShow(list) {
      this.dialog.dialogVisible = true
      this.dialog.list = list
    },
    // 上传材料
    replenishs() {
      this.materials.id = this.$route.query.id
      this.materials.dialogVisible = true
    },
    submitAdds() {
      this.$refs.materials.validate(valid => {
        if (!valid) return false
        this.materials.loading = true
        const parmas = {
          personalAwardId: this.materials.id,
          declareReportFilePaths: this.materials.declarePdfPath
        }
        addPersonalAwardThree(parmas).then(res => {
          this.materials.loading = false
          if (res.code === '000') {
            this.$message.success('操作成功')
            this.materials.dialogVisible = false
            this.getDetails()
          }
        })
      })
    },
    closeMaterials() {
      this.$refs.materials.resetFields()
      this.materials.declarePdfFiles = []
    },
    // 撤回
    handleCh(row, index) {
      this.$confirm('是否确定撤回该申报?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        increasedPersonalWithdraw({ id: this.$route.query.id }).then(res => {
          if (res.code == '000') {
            this.$message.success('操作成功')
            this.getDetails()
          }
        })
      }).catch(() => {})
    },
    // 跳转编辑
    handleEdit() {
      this.$router.push({ path: '/personal/add1', query: { id: this.$route.query.id, batchId: this.$route.query.batchId } })
    },
    // 下载文件
    handleUploadFinal(path, name) {
      const elink = document.createElement('a')
      elink.download = name
      elink.style.display = 'none'
      elink.href = '/fid/' + path
      document.body.appendChild(elink)
      elink.click()
      URL.revokeObjectURL(elink.href)
      document.body.removeChild(elink)
    },
    handleUploadAward(path) {
      AdminDownLoadFile({ path }).then(res => {
        const blob = new Blob([res.data])
        const fileName = decodeURIComponent(res.headers['content-disposition'].split(';')[1].split('filename=')[1])
        if ('download' in document.createElement('a')) { // 非IE下载
          const elink = document.createElement('a')
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href) // 释放URL 对象
          document.body.removeChild(elink)
        } else { // IE10+下载
          navigator.msSaveBlob(blob, fileName)
        }
      })
    },
    getStatus() {
      return getMangerStatus().then(res => {
        if (res.code == '000') {
          this.personalState = res.result.personalState
        }
      })
    }
  }
}
</script>

<style lang="less" >
.el-descriptions-item__label.is-bordered-label {
  width: 150px;
}
.z {
  justify-content: center;
  align-items: center;
}
</style>
